<template>
    <div id="ProjectPanelTextarea">
        <eb-panel>
            <eb-panel-header class="panel-header" slot="header">
                <span slot="title">{{title}}</span>
            </eb-panel-header>
            <div slot="body">
                <el-input type="textarea" class="eb-textarea" :autosize="{ minRows: 4, maxRows: 10}" placeholder="请输入内容" v-model="project.projectComment">
                </el-input>
            </div>
        </eb-panel>
    </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
export default {
  name: 'ProjectPanelTextarea',
  props: {
    project: {
      required: true
    },
    title: {
      required: true,
      type: String
    }
  },
  components: {
    ebPanel,
    ebPanelHeader
  }
};
</script>
<style scoped lang="less">
.eb-textarea{
    margin-top:10px;
}
</style>
